import React from 'react';
import styled from '@emotion/styled';
import { Grid, GridItem, Spacer } from 'ech-components/src/helpers';
import { colors, spaces } from 'ech-components/src/core/styles/theme/default';
import { rem } from 'polished';
import { scroller } from 'react-scroll';

const StyledTitle = styled.h5`
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  margin: 0;
`;

const StyledSectionNav = styled.nav`
  display: flex;
  list-style: none;
  margin-left: ${rem(-16)};
  padding: ${rem(10)} 0;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: ${colors.primarySunYellow300} transparent;

  &::-webkit-scrollbar {
    height: ${rem(spaces.alpha)};
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.primarySunYellow300};
    border-radius: ${rem(spaces.alpha)};
  }
`;

const StyledSectionNavLink = styled.a`
  cursor: pointer;
  padding: 0 ${rem(16)};
  font-weight: 400;
  font-size: ${rem(16)};
  line-height: 1.7;
  white-space: nowrap;
  color: ${colors.grey700};
`;

export const NavSection = ({
  displayTitle = true,
  gridItemSize = { zero: 12, ultra: 12 },
  gridItemPush = { zero: 0, ultra: 2 },
  items = [],
  sectionHeaderTitle,
}: {
  displayTitle?: boolean;
  gridItemSize?: any;
  gridItemPush?: any;
  items?: any;
  sectionHeaderTitle?: string;
}) => {
  const sections = items.map((item: { id: string; meta: string }) => ({
    ...item,
    onClick: () =>
      scroller.scrollTo(item.id, {
        smooth: true,
        offset: -120,
      }),
  }));

  return (
    <Grid columns={12}>
      <GridItem size={gridItemSize} push={gridItemPush}>
        <div>
          {displayTitle ? (
            <StyledTitle>{sectionHeaderTitle}</StyledTitle>
          ) : null}
          <Spacer space="alpha" />
          <StyledSectionNav>
            {sections.map(
              ({
                id,
                onClick,
                meta,
              }: {
                id: string;
                onClick: () => void;
                meta: string;
              }) =>
                meta && (
                  <StyledSectionNavLink onClick={onClick} key={id} tabIndex={0}>
                    {meta}
                  </StyledSectionNavLink>
                ),
            )}
          </StyledSectionNav>
        </div>
      </GridItem>
    </Grid>
  );
};

export type NavSectionProps = {};

export default NavSection;
